// Type Definitions

interface QuestionOption {
  key: string;
  value: string;
}

interface ValidationRule {
  type: string;
  value?: number;
  error_message: string;
}

export interface Question {
  question_id: number;
  question: string;
  explanation_text: string;
  question_type: "input" | "radio" | "multi-select" | "text";
  question_options: QuestionOption[];
  answer: any | null;
  validation_rules: ValidationRule[];
  ai_processing_hint: string;
}

const data: Question[] = [
  // {
  //   question_id: 1,
  //   question: "Patient Name?",
  //   explanation_text: "Patient full legal name",
  //   question_type: "input",
  //   question_options: [],
  //   answer: null,
  //   validation_rules: [
  //     { type: "required", error_message: "Patient name is required" },
  //     { type: "min_length", value: 2, error_message: "Name is too short" },
  //   ],
  //   ai_processing_hint: "Patient name identification",
  // },
  {
    question_id: 2,
    question: "Age",
    explanation_text: "Patient age in years",
    question_type: "input",
    question_options: [],
    answer: null,
    validation_rules: [
      { type: "required", error_message: "Age is required" },
      { type: "number", error_message: "Please enter a valid number" },
      { type: "min_length", value: 1, error_message: "Minimum age is 1" },
      {
        type: "max_length",
        value: 3,
        error_message: "Please enter a valid age",
      },
    ],
    ai_processing_hint: "Numeric age categorization",
  },
  {
    question_id: 3,
    question: "Gender",
    explanation_text: "Select patient gender",
    question_type: "radio",
    question_options: [
      { key: "male", value: "Male" },
      { key: "female", value: "Female" },
      { key: "other", value: "Other" },
    ],
    answer: null,
    validation_rules: [
      { type: "required", error_message: "Gender selection is required" },
    ],
    ai_processing_hint: "Gender demographic tracking",
  },
  {
    question_id: 4,
    question: "HbA1C",
    explanation_text: "Enter patient's HbA1C value",
    question_type: "input",
    question_options: [],
    answer: null,
    validation_rules: [
      { type: "required", error_message: "HbA1C value is required" },
      { type: "number", error_message: "Please enter a numeric value" },
    ],
    ai_processing_hint: "HbA1C level analysis and interpretation",
  },
  {
    question_id: 5,
    question: "Serum Phosphate (mg/dL)",
    explanation_text: "Enter patient's Serum Phosphate value in mg/dL",
    question_type: "input",
    question_options: [],
    answer: null,
    validation_rules: [
      { type: "required", error_message: "Serum Phosphate value is required" },
      { type: "number", error_message: "Please enter a numeric value" },
    ],
    ai_processing_hint: "Serum Phosphate level assessment",
  },
  {
    question_id: 6,
    question: "Serum Calcium (mg/dL)",
    explanation_text: "Enter patient's Serum Calcium value in mg/dL",
    question_type: "input",
    question_options: [],
    answer: null,
    validation_rules: [
      { type: "required", error_message: "Serum Calcium value is required" },
      { type: "number", error_message: "Please enter a numeric value" },
    ],
    ai_processing_hint: "Serum Calcium level assessment",
  },
  {
    question_id: 7,
    question: "Adherence Therapy",
    explanation_text: "Rate patient's adherence to prescribed therapy",
    question_type: "radio",
    question_options: [
      { key: "good", value: "Good" },
      { key: "fair", value: "Fair" },
      { key: "poor", value: "Poor" },
    ],
    answer: null,
    validation_rules: [
      { type: "required", error_message: "Adherence rating is required" },
    ],
    ai_processing_hint: "Therapy adherence assessment",
  },
  {
    question_id: 8,
    question: "Additional Health Observations",
    explanation_text:
      "Please describe any additional health concerns, symptoms, or changes you've noticed since patient's last consultation",
    question_type: "text",
    question_options: [],
    answer: null,
    validation_rules: [
      {
        type: "min_length",
        value: 20,
        error_message: "Please provide more details",
      },
      {
        type: "max_length",
        value: 500,
        error_message: "Please keep your response concise (500 characters max)",
      },
    ],
    ai_processing_hint:
      "Extract key health observations, symptoms, and patient-reported concerns for medical review",
  },
];

export default data;

// {
//   question_id: 4,
//   question: "Profession",
//   explanation_text: "Select all applicable professional backgrounds",
//   question_type: "multi-select",
//   question_options: [
//     { key: "healthcare", value: "Healthcare" },
//     { key: "education", value: "Education" },
//     { key: "corporate", value: "Corporate" },
//     { key: "self_employed", value: "Self-Employed" },
//     { key: "student", value: "Student" },
//     { key: "retired", value: "Retired" },
//     { key: "other", value: "Other" },
//   ],
//   answer: null,
//   validation_rules: [
//     {
//       type: "required",
//       error_message: "Please select at least one profession",
//     },
//   ],
//   ai_processing_hint: "Professional background classification",
// },